"use client";
import { cn as e } from "../lib/utils.js";
import * as t from "react";
import { cva as n } from "class-variance-authority";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { X as a } from "lucide-react";
import * as o from "@radix-ui/react-dialog";
//#region src/shadcn/sheet.tsx
var s = o.Root, c = o.Trigger, l = o.Close, u = o.Portal, d = t.forwardRef(({ className: t, ...n }, i) => /* @__PURE__ */ r(o.Overlay, {
	className: e("fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", t),
	...n,
	ref: i
}));
d.displayName = o.Overlay.displayName;
var f = n("fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500", {
	variants: { side: {
		top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
		bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
		left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
		right: "inset-y-0 right-0 h-full w-3/4  border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
	} },
	defaultVariants: { side: "right" }
}), p = t.forwardRef(({ side: t = "right", className: n, children: s, ...c }, l) => /* @__PURE__ */ i(u, { children: [/* @__PURE__ */ r(d, {}), /* @__PURE__ */ i(o.Content, {
	ref: l,
	className: e(f({ side: t }), n),
	...c,
	children: [s, /* @__PURE__ */ i(o.Close, {
		className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary",
		children: [/* @__PURE__ */ r(a, { className: "h-4 w-4" }), /* @__PURE__ */ r("span", {
			className: "sr-only",
			children: "Close"
		})]
	})]
})] }));
p.displayName = o.Content.displayName;
var m = ({ className: t, ...n }) => /* @__PURE__ */ r("div", {
	className: e("flex flex-col space-y-2 text-center sm:text-left", t),
	...n
});
m.displayName = "SheetHeader";
var h = ({ className: t, ...n }) => /* @__PURE__ */ r("div", {
	className: e("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", t),
	...n
});
h.displayName = "SheetFooter";
var g = t.forwardRef(({ className: t, ...n }, i) => /* @__PURE__ */ r(o.Title, {
	ref: i,
	className: e("text-lg font-semibold text-foreground", t),
	...n
}));
g.displayName = o.Title.displayName;
var _ = t.forwardRef(({ className: t, ...n }, i) => /* @__PURE__ */ r(o.Description, {
	ref: i,
	className: e("text-sm text-muted-foreground", t),
	...n
}));
_.displayName = o.Description.displayName;
//#endregion
export { s as Sheet, l as SheetClose, p as SheetContent, _ as SheetDescription, h as SheetFooter, m as SheetHeader, d as SheetOverlay, u as SheetPortal, g as SheetTitle, c as SheetTrigger };
